// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mediasfu-waiting-modal .waiting-list {
  display: flex;
  flex-direction: column;
}

.mediasfu-waiting-modal .waiting-item {
  display: flex; /* Change display to flex */
  flex-direction: row; /* Set flexDirection to row */
  margin-top: 5px;
}

.mediasfu-waiting-modal .col7 {
  flex: 5;
  justify-content: center;
}

.mediasfu-waiting-modal .col2 {
  flex: 2;
  align-items: center;
  justify-content: center;
}

.mediasfu-waiting-modal .col1 {
  flex: 1;
}

.mediasfu-waiting-modal .btn-close-waitings {
  margin-left: auto;
  margin-right: 10px;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/components/waitingComponents/WaitingRoomModal.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa,EAAE,2BAA2B;EAC1C,mBAAmB,EAAE,6BAA6B;EAClD,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,uBAAuB;AACzB;;AAEA;EACE,OAAO;EACP,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB","sourcesContent":[".mediasfu-waiting-modal .waiting-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.mediasfu-waiting-modal .waiting-item {\r\n  display: flex; /* Change display to flex */\r\n  flex-direction: row; /* Set flexDirection to row */\r\n  margin-top: 5px;\r\n}\r\n\r\n.mediasfu-waiting-modal .col7 {\r\n  flex: 5;\r\n  justify-content: center;\r\n}\r\n\r\n.mediasfu-waiting-modal .col2 {\r\n  flex: 2;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.mediasfu-waiting-modal .col1 {\r\n  flex: 1;\r\n}\r\n\r\n.mediasfu-waiting-modal .btn-close-waitings {\r\n  margin-left: auto;\r\n  margin-right: 10px;\r\n  cursor: pointer;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
